import { Injectable } from '@angular/core';
import { PCacheable } from 'ts-cacheable';
import { JobCategoryDto } from '../../beneficiaries/beneficiary-details/employment/dto/job-category.dto';
import { environment } from '../../environments/environment';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class JobService {
  constructor(private readonly api: ApiService) {}

  @PCacheable()
  public async findAll(): Promise<JobCategoryDto[]> {
    return await this.api.get<JobCategoryDto[]>(environment.api.jobs);
  }
}
